export type DocLink = { label: string; href: string };
export type DocGroup = { group: string; links: DocLink[] };

export const docsNav: DocGroup[] = [
  {
    group: "Getting Started",
    links: [
      { label: "Introduction", href: "/docs#introduction" },
      { label: "Installation", href: "/docs#installation" },
      { label: "Hardware Setup", href: "/docs#hardware" },
    ],
  },
  {
    group: "Using NodeDR POS",
    links: [
      { label: "POS Checkout", href: "/docs#pos-checkout" },
      { label: "Inventory Management", href: "/docs#inventory" },
      { label: "GST & Tax Billing", href: "/docs#gst-billing" },
      { label: "Customer Dues (Udhaar)", href: "/docs#loyalty-dues" },
      { label: "Returns & Exchanges", href: "/docs#returns" },
      { label: "Receipts & Printing", href: "/docs#receipts" },
      { label: "Sales Dashboard", href: "/docs#dashboard" },
      { label: "Customer Display", href: "/docs#customer-display" },
      { label: "Suppliers & Purchasing", href: "/docs#purchasing" },
      { label: "Online Orders", href: "/docs#online-orders" },
    ],
  },
  {
    group: "Administration",
    links: [
      { label: "Staff Accounts & Roles", href: "/docs#staff" },
      { label: "Settings", href: "/docs#settings" },
      { label: "Backup & Restore", href: "/docs#backup" },
    ],
  },
  {
    group: "Developer",
    links: [
      { label: "API Reference", href: "/docs#api" },
      { label: "External API & Webhooks", href: "/docs#external-api" },
      { label: "Security Model", href: "/docs#security" },
      { label: "Contributing", href: "/docs#contributing" },
    ],
  },
];
